export default __webpack_public_path__ + "static/business_setup-9457dbf71529044fedd3a711bc2c0c0b.png";